const API_URL = process.env.REACT_APP_API_URL;
const baseApiUrl = `${API_URL}/api/user`;

export default {
    signup: `${baseApiUrl}/signup`,
    upload: `${baseApiUrl}/upload`,
    locations: `${baseApiUrl}/locations`,
    unique: `${baseApiUrl}/unique-code/`,
    journeyStatus: `${baseApiUrl}/journey-status/`,
    distance: `${baseApiUrl}/distance/`,
    swipe: `${baseApiUrl}/swipe/`,
    redeem: `${baseApiUrl}/redeem/`,
    venueSelect: `${baseApiUrl}/venue-select/`,
    selectedVenue: `${baseApiUrl}/selected-venue/`,
    checkUser: `${baseApiUrl}/check-user/`,
    origin: `${baseApiUrl}/landing/`,
    checkCampaign: `${baseApiUrl}/check-campaign`,
    resendEmail: `${baseApiUrl}/resend-email/`,
    getCampaignContent: `${baseApiUrl}/campaign`,
    verifyRecaptchaToken: `${baseApiUrl}/verify-token`,
    checkUrlToken: `${baseApiUrl}/check-url/`,
    instant: `${API_URL}/api/instant-win`,
    whatsappShare: `${API_URL}/api/campaign/whatsapp-share-count`,
    prediction: `${API_URL}/api/prediction`,
    validateEmail: `${baseApiUrl}/validate-email`,
    integrationSession: `${API_URL}/api/integration/session/`,
    integrationClaim: `${API_URL}/api/integration/claim`,
};
